export default __webpack_public_path__ + "static/media/deleteThanks_woman-baw.5c62dd1a.svg";